import {
  Button,
  Typography,
  Box,
  styled,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import ToastSnackbar, { SnackbarHandle } from "../../common/ToastNotification";
import HomeIcon from "@mui/icons-material/Home";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import React, { useEffect, useState } from "react";
import { ClassAndSectionStrength } from "../../api/Report-Center/student-details";

import { Grid, Card, CardContent, Container, Divider } from "@mui/material";
import {
  PeopleAlt as TotalIcon,
  Groups as SectionIcon,
  HourglassTop as PendingIcon,
} from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import { Chip } from "@mui/material";
import {
  GetFeeDuesReport,
  GetStudentMasterData,
  GetCategoryWiseData,
  GetTransportData,
  GetStopWiseData,
} from "../../api/Report-Center/fee-collection";
import { sortClassData } from "../../helper/helper";
import { useApi } from "../../store/UserLoginContext";

const MyCustomButton = styled(Button)(({ theme }) => ({
  fontFamily: "Motiva Sans Bold",
  fontSize: "0.80rem",
  fontWeight: "700",
  border: "1px solid #edf3f5",
  borderRadius: "4px",
  background: "#2e186a",
  boxShadow: "0 16px 30px rgb(23 31 114 / 20%)",
  marginTop: "0rem",
  "&:hover": {
    color: "#fff",
    border: "1px solid rgb(255, 130, 92)",
    backgroundColor: "rgb(255, 130, 92)",
  },
}));
const AnimatedButton = ({
  label,
  onClick,
  disabled,
  type,
  startIcon,
}: {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: "submit" | "reset" | "button";
  startIcon?: any;
}) => {
  return (
    <Button
      variant="text"
      onClick={onClick}
      type={type}
      sx={{
        position: "relative",
        // fontFamily: "Motiva Sans Bold",
        // fontWeight: "Bold",
        padding: "0 10px",
        fontSize: "14px",
        textTransform: "none",
        color: "#2e186a",
        "&:hover": {
          fontWeight: "Bold",
        },
        "&::after": {
          content: '""',
          fontWeight: "Bold",
          position: "absolute",
          width: "0",
          height: "2px",
          left: "0",
          bottom: "-2px",
          backgroundColor: "rgb(255, 130, 92)",
          transition: "width 0.3s ease-in-out",
        },
        "&:hover::after": {
          width: "100%", // Underline expands on hover
        },
      }}
      disabled={disabled == null ? true : disabled}
      startIcon={startIcon}
    >
      {label}
      {/* <strong>{label}</strong> */}
    </Button>
  );
};

const ClassSectionStrength = () => {
  const { currentSessionAY } = useApi();
  const snackbarRef = React.useRef<SnackbarHandle>(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [selectedSection, setSelectedSection] = useState({});

  const [fetchingDueReport, setFetchingDueReport] = useState(false);
  const [fetchingStudentMasterData, setFetchingStudentMasterData] =
    useState(false);
  const [fetchingCategoryWiseReport, setFetchingCategoryWiseReport] =
    useState(false);
  const [fetchingTransportDataReport, setFetchingTransportDataReport] =
    useState(false);
  const [fetchingStopWiseData, setFetchingStopWiseData] = useState(false);

  const [classData, setclassData] = useState<any>({});

  //@ts-ignore
  const SectionRow = ({ icon, label, count, color }) => (
    <Box display="flex" alignItems="center" gap={1} mt={1}>
      <Box color={color}>{icon}</Box>
      <Typography variant="body2" color="text.secondary" fontWeight={"bold"}>
        {label}:
      </Typography>
      <Typography variant="body2" fontWeight={500}>
        {count}
      </Typography>
    </Box>
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [classes_records] = await Promise.all([
          ClassAndSectionStrength(),
        ]);

        if (classes_records && classes_records.result.documents.length > 0) {
          const result = {};

          classes_records.result.documents.forEach(
            //@ts-ignore
            ({ class_name, section_name, class_id, section_id }) => {
              //@ts-ignore
              if (!result[class_name]) {
                //@ts-ignore
                result[class_name] = { total: 0, _meta: {} }; // _meta to hold section/class metadata
              }

              //@ts-ignore
              if (!result[class_name][section_name]) {
                //@ts-ignore
                result[class_name][section_name] = 0;
              }

              //@ts-ignore
              result[class_name][section_name]++;
              //@ts-ignore
              result[class_name].total++;

              // Store metadata
              //@ts-ignore
              result[class_name]._meta[section_name] = {
                class_id,
                section_id,
              };
            }
          );

          const result_sorted = sortClassData(result);
          console.log("****** Response Received *********");
          console.log(result_sorted);
          setclassData(result_sorted);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        snackbarRef.current?.showSnackbar(`Error fetching data`, "error");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  //@ts-ignore
  const handleSectionChange = (className, section) => {
    setSelectedSection({});
    setSelectedSection((prev) => ({
      ...prev,
      [className]: section,
    }));
  };

  const generateStudentMasterData = async () => {
    try {
      setFetchingStudentMasterData(true);

      const response = await GetStudentMasterData();
      console.log("*************RESPONSE************");
      console.log(response);
      if (response && response?.status && response?.status === "NO_RECORDS") {
        snackbarRef.current?.showSnackbar(`${response?.message}`, "warning");
      }
    } catch (error) {
      console.log(error);
      snackbarRef.current?.showSnackbar(`Some error occured`, "error");
    } finally {
      setFetchingStudentMasterData(false);
    }
  };

  const generateFeeDueReport = async (reportType: any, className: any) => {
    try {
      //@ts-ignore
      if (!selectedSection[className]) {
        snackbarRef.current?.showSnackbar(
          `Select Any Section To Fetch Report`,
          "warning"
        );
        return;
      }

      setFetchingDueReport(true);
      //@ts-ignore
      setFetchingDueReport((prev) => ({ ...prev, [className]: true }));
      //@ts-ignore
      console.log(reportType, className, selectedSection[className]);
      //@ts-ignore
      const selected_section = selectedSection[className];
      const class_section = classData[className]._meta[selected_section];
      if (class_section.class_id && class_section.section_id) {
        const payload = {
          class_id: class_section.class_id,
          section_id: class_section.section_id,
          academic_year: currentSessionAY,
        };

        const resp = await GetFeeDuesReport(payload);
        console.log("******* resp ************");
        console.log(resp);
        if (resp && resp?.status && resp?.status === "NO_RECORDS") {
          snackbarRef.current?.showSnackbar(`${resp?.message}`, "warning");
        }
      } else {
        snackbarRef.current?.showSnackbar(
          `Class Or Section Not Found`,
          "warning"
        );
        return;
      }
    } catch (error) {
      snackbarRef.current?.showSnackbar(`Some Error Occured.`, "error");
      return;
    } finally {
      setFetchingDueReport(false);
    }
  };

  const getCategoryWiseData = async (reportType: any, className: any) => {
    try {
      //@ts-ignore
      if (!selectedSection[className]) {
        snackbarRef.current?.showSnackbar(
          `Select Any Section To Fetch Report`,
          "warning"
        );
        return;
      }

      setFetchingCategoryWiseReport(true);
      //@ts-ignore
      setFetchingCategoryWiseReport((prev) => ({ ...prev, [className]: true }));
      //@ts-ignore
      console.log(reportType, className, selectedSection[className]);
      //@ts-ignore
      const selected_section = selectedSection[className];
      const class_section = classData[className]._meta[selected_section];

      if (class_section.class_id && class_section.section_id) {
        const payload = {
          class_id: class_section.class_id,
          section_id: class_section.section_id,
        };

        const resp = await GetCategoryWiseData(payload);
        console.log("******* resp ************");
        console.log(resp);
        if (resp && resp?.status && resp?.status === "NO_RECORDS") {
          snackbarRef.current?.showSnackbar(`${resp?.message}`, "warning");
        }
      } else {
        snackbarRef.current?.showSnackbar(
          `Class Or Section Not Found`,
          "warning"
        );
        return;
      }
    } catch (error) {
      snackbarRef.current?.showSnackbar(`Some Error Occured.`, "error");
      return;
    } finally {
      setFetchingCategoryWiseReport(false);
    }
  };

  const getTransportData = async (reportType: any, className: any) => {
    try {
      //@ts-ignore
      if (!selectedSection[className]) {
        snackbarRef.current?.showSnackbar(
          `Select Any Section To Fetch Report`,
          "warning"
        );
        return;
      }

      setFetchingTransportDataReport(true);
      //@ts-ignore
      setFetchingTransportDataReport((prev) => ({
        //@ts-ignore
        ...prev,
        [className]: true,
      }));
      //@ts-ignore
      console.log(reportType, className, selectedSection[className]);
      //@ts-ignore
      const selected_section = selectedSection[className];
      const class_section = classData[className]._meta[selected_section];

      if (class_section.class_id && class_section.section_id) {
        const payload = {
          class_id: class_section.class_id,
          section_id: class_section.section_id,
        };

        const resp = await GetTransportData(payload);
        console.log("******* resp ************");
        console.log(resp);
        if (resp && resp?.status && resp?.status === "NO_RECORDS") {
          snackbarRef.current?.showSnackbar(`${resp?.message}`, "warning");
        }
      } else {
        snackbarRef.current?.showSnackbar(
          `Class Or Section Not Found`,
          "warning"
        );
        return;
      }
    } catch (error) {
      snackbarRef.current?.showSnackbar(`Some Error Occured.`, "error");
      return;
    } finally {
      setFetchingTransportDataReport(false);
    }
  };

  const getStopWiseData = async (reportType: any, className: any) => {
    try {
      //@ts-ignore
      if (!selectedSection[className]) {
        snackbarRef.current?.showSnackbar(
          `Select Any Section To Fetch Report`,
          "warning"
        );
        return;
      }

      setFetchingStopWiseData(true);
      //@ts-ignore
      setFetchingStopWiseData((prev) => ({ ...prev, [className]: true }));
      //@ts-ignore
      console.log(reportType, className, selectedSection[className]);
      //@ts-ignore
      const selected_section = selectedSection[className];
      const class_section = classData[className]._meta[selected_section];

      if (class_section.class_id && class_section.section_id) {
        const payload = {
          class_id: class_section.class_id,
          section_id: class_section.section_id,
        };

        const resp = await GetStopWiseData(payload);
        console.log("******* resp ************");
        console.log(resp);
        if (resp && resp?.status && resp?.status === "NO_RECORDS") {
          snackbarRef.current?.showSnackbar(`${resp?.message}`, "warning");
        }
      } else {
        snackbarRef.current?.showSnackbar(
          `Class Or Section Not Found`,
          "warning"
        );
        return;
      }
    } catch (error) {
      snackbarRef.current?.showSnackbar(`Some Error Occured.`, "error");
      return;
    } finally {
      setFetchingStopWiseData(false);
    }
  };

  return (
    <>
      <ToastSnackbar ref={snackbarRef} />
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        p={2}
        pb={0}
        gap={1}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-start"}
          p={2}
          pb={0}
          gap={1}
        >
          <MyCustomButton
            variant="contained"
            startIcon={<ArrowLeftIcon />}
            onClick={() => navigate("..")}
          >
            Go Back
          </MyCustomButton>
          <MyCustomButton
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => navigate("/home")}
          >
            Home
          </MyCustomButton>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-end"}
          p={2}
          pb={0}
          gap={1}
        >
          <MyCustomButton
            variant="contained"
            onClick={generateStudentMasterData}
            startIcon={
              fetchingStudentMasterData ? <CircularProgress size={20} /> : null
            }
            disabled={fetchingStudentMasterData}
          >
            {fetchingStudentMasterData ? "" : "Student Master Data"}
          </MyCustomButton>
        </Box>
      </Box>

      <Box
        display={"flex"}
        flexDirection={"column"}
        p={2}
        pt={0}
        height="auto"
        width="auto"
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          p={2}
          pt={0}
          height="auto"
          justifyContent={"center"}
          alignItems={"center"}
          width={"90vw"}
        >
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-evenly"}
            gap={3}
            width="auto"
            mt={4}
          >
            {loading ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100px"
              >
                <CircularProgress size={40} />
              </Box>
            ) : (
              <Container maxWidth="lg" sx={{ py: 4 }}>
                <Typography variant="h4" gutterBottom fontWeight={600}>
                  📊 Class-wise Student Overview
                </Typography>
                <Grid container spacing={3}>
                  {Object.entries(classData).map(([className, details]) => (
                    <Grid item xs={12} sm={6} md={4} key={className}>
                      <Card
                        sx={{
                          borderRadius: 3,
                          boxShadow: 4,
                          height: "100%",
                          transition:
                            "transform 0.2s ease, box-shadow 0.2s ease",
                          "&:hover": {
                            transform: "scale(1.03)",
                            boxShadow: 6,
                            cursor: "pointer",
                            backgroundColor: "rgba(0, 0, 255, 0.02)", // light blue tint
                          },
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <CardContent>
                          {/* Class Heading */}
                          <Typography
                            variant="h5"
                            color="primary"
                            gutterBottom
                            fontWeight={700}
                          >
                            Class {className}
                          </Typography>

                          {/* Total Students */}
                          <SectionRow
                            icon={<TotalIcon />}
                            label="Total Students"
                            //@ts-ignore
                            count={details.total}
                            color="primary.main"
                          />

                          <Divider
                            style={{
                              color: "#FF825B",
                              border: "1px solid",
                              marginTop: 2,
                              marginBottom: 2,
                            }}
                          />

                          {/* Sections */}
                          {["A", "B", "C", "D", "E", "F", "G", "H", "I"].map(
                            (section) =>
                              //@ts-ignore
                              details[section] !== undefined ? (
                                <SectionRow
                                  key={section}
                                  icon={<SectionIcon fontSize="small" />}
                                  label={`Section ${section}`}
                                  //@ts-ignore
                                  count={details[section]}
                                  color="text.secondary"
                                />
                              ) : null
                          )}

                          {/* Pending (if any) */}
                          {/* @ts-ignore */}
                          {details.PENDING && (
                            <SectionRow
                              icon={<PendingIcon fontSize="small" />}
                              label="Pending"
                              //@ts-ignore
                              count={details.PENDING}
                              color="warning.main"
                            />
                          )}
                        </CardContent>
                        <Box
                          sx={{
                            mt: "auto",
                            px: 2,
                            py: 1,
                            borderTop: "1px solid #eee",
                            backgroundColor: "grey.50",
                          }}
                        >
                          {/* Reports label */}
                          <Box display="flex" alignItems="center" mb={1}>
                            <Typography
                              variant="subtitle2"
                              fontWeight={600}
                              color="text.secondary"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <DescriptionIcon
                                fontSize="small"
                                sx={{ ml: 1 }}
                              />
                              Reports
                            </Typography>
                          </Box>

                          <Box
                            display="flex"
                            gap={1}
                            mt={1}
                            flexWrap="wrap"
                            sx={{
                              maxHeight: 90, // optional: limit height
                              overflowY: "auto",
                              pr: 1,
                            }}
                          >
                            {/* @ts-ignore */}
                            {Object.keys(details)
                              .filter(
                                (key) =>
                                  key !== "total" &&
                                  key !== "PENDING" &&
                                  key !== "_meta"
                              )
                              .map((sec) => (
                                //@ts-ignore
                                <Chip
                                  key={sec}
                                  label={`Section ${sec}`}
                                  value={sec}
                                  color={
                                    //@ts-ignore
                                    selectedSection[className] === sec
                                      ? "primary"
                                      : "default"
                                  }
                                  size="small"
                                  onClick={() =>
                                    handleSectionChange(className, sec)
                                  }
                                />
                              ))}
                          </Box>

                          {/* Report links */}
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            flexWrap="wrap"
                            mt={1}
                            gap={1}
                          >
                            <Box
                              key={"Fee Due"}
                              sx={{
                                cursor: "pointer",
                                fontWeight: 500,
                                fontSize: "0.8rem",
                                "&:hover": {
                                  textDecoration: "underline",
                                },
                              }}
                            >
                              <AnimatedButton
                                label={"Fee Due"}
                                onClick={() =>
                                  generateFeeDueReport("Fee Due", className)
                                }
                                //@ts-ignore
                                disabled={true}
                                startIcon={
                                  //@ts-ignore
                                  fetchingDueReport[className] === true ? (
                                    <CircularProgress size={8} />
                                  ) : undefined
                                }
                              />
                            </Box>
                            <Box
                              key={"Category"}
                              sx={{
                                cursor: "pointer",
                                fontWeight: 500,
                                fontSize: "0.8rem",
                                "&:hover": {
                                  textDecoration: "underline",
                                },
                              }}
                            >
                              <AnimatedButton
                                label={"Category"}
                                onClick={() =>
                                  getCategoryWiseData("Category", className)
                                }
                                //@ts-ignore
                                disabled={fetchingCategoryWiseReport}
                                startIcon={
                                  //@ts-ignore
                                  fetchingCategoryWiseReport[className] ===
                                  true ? (
                                    <CircularProgress size={8} />
                                  ) : undefined
                                }
                              />
                            </Box>
                            <Box
                              key={"Transport"}
                              sx={{
                                cursor: "pointer",
                                fontWeight: 500,
                                fontSize: "0.8rem",
                                "&:hover": {
                                  textDecoration: "underline",
                                },
                              }}
                            >
                              <AnimatedButton
                                label={"Transport"}
                                onClick={() =>
                                  getTransportData("Transport", className)
                                }
                                //@ts-ignore
                                disabled={fetchingTransportDataReport}
                                startIcon={
                                  //@ts-ignore
                                  fetchingTransportDataReport[className] ===
                                  true ? (
                                    <CircularProgress size={8} />
                                  ) : undefined
                                }
                              />
                            </Box>
                            <Box
                              key={"Stops"}
                              sx={{
                                cursor: "pointer",
                                fontWeight: 500,
                                fontSize: "0.8rem",
                                "&:hover": {
                                  textDecoration: "underline",
                                },
                              }}
                            >
                              <AnimatedButton
                                label={"Stops"}
                                onClick={() =>
                                  getStopWiseData("Stops", className)
                                }
                                //@ts-ignore
                                disabled={fetchingStopWiseData}
                                startIcon={
                                  //@ts-ignore
                                  fetchingStopWiseData[className] === true ? (
                                    <CircularProgress size={8} />
                                  ) : undefined
                                }
                              />
                            </Box>
                          </Box>
                        </Box>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Container>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ClassSectionStrength;
